export default __webpack_public_path__ + "static/media/rabit-example.ac447039.png";